/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Members_Seats_Change_BaseInputs */



/**
* | output |
* | --- |
* | "Change the type of an empty base seat under Subscriptions" |
*
* @param {Members_Seats_Change_BaseInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_seats_change_base = /** @type {((inputs?: Members_Seats_Change_BaseInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Seats_Change_BaseInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Typ eines freien Basisplatzes unter Abos ändern")
	return /** @type {LocalizedString} */ ("Change the type of an empty base seat under Subscriptions")
});